// extracted by mini-css-extract-plugin
export default {"headline":"nRrDw_"};